import { memo } from "react";

const initials = (name: string) =>
  name.replace(/[.'"]/g, "").split(/\s+/).filter((w) => /^[A-Z]/.test(w) && w !== "Jr").map((w) => w[0]).filter((_, i, a) => i === 0 || i === a.length - 1).join("");

/** Design: Face / Face/Initials. Photo when known, otherwise initials. Always named for a11y. */
export const Face = memo(function Face({ name, photoUrl, size = 24 }: { name: string; photoUrl?: string | null; size?: number }) {
  return photoUrl ? (
    <img className="face" src={photoUrl} alt={name} width={size} height={size} style={{ ["--face" as string]: `${size}px` }} loading="lazy" decoding="async" />
  ) : (
    <span className="face face--initials" role="img" aria-label={name} style={{ ["--face" as string]: `${size}px`, width: size, height: size, fontSize: Math.round(size * 0.38) }}>
      {initials(name)}
    </span>
  );
});

/** Design: overlapping faces, max 4 + "+N", step = 0.68 × size. */
export function FaceStack({ people, size = 24, max = 4 }: {
  people: { name: string; photoUrl?: string | null }[];
  size?: number;
  max?: number;
}) {
  const shown = people.slice(0, max);
  const extra = people.length - shown.length;
  return (
    <span className="face-stack" style={{ ["--face" as string]: `${size}px` }}>
      {shown.map((p) => <Face key={p.name} {...p} size={size} />)}
      {extra > 0 && <span className="face-stack__more">+{extra}</span>}
    </span>
  );
}
